export const FP_ONLY_PATHS = [
  'fp.fontCanvas.hash',
  'fp.fontCanvas.details.measurement',
  'fp.webgl.hash',
  'fp.webgl2.hash',
  'highEntropyValues.architecture',
  'highEntropyValues.bitness',
  'highEntropyValues.wow64',
  'webWorker.highEntropyValues.architecture',
  'webWorker.highEntropyValues.bitness',
  'webWorker.highEntropyValues.wow64',
  'javascript.screen.availWidth',
  'javascript.screen.availHeight',
  'javascript.screen.availTop',
  'javascript.screen.availLeft',
  'javascript.date.hoursCycle',
  'mediaQueries.preferredColorScheme',
];

export const DI_ONLY_PATHS = [
  'javascript.battery',
  'javascript.screen.colorDepth',
  'javascript.screen.pixelDepth',
  'browser.other.sensors',
  'browser.other.navigation',
  'browser.other.timezone',
  'browser.other.network.rtt',
  'browser.other.network.downlink',
  'browser.other.network.downlinkMax',
  'browser.other.network.effectiveType',
  'browser.other.capabilities.apis',
  'mediaQueries.dynamicRange',
  'mediaQueries.colorGamut',
  'mediaQueries.monochrome',
  'features.applePay.canMP',
];

const KEPT_PERMISSION = 'window-management';

function deletePath(obj, path) {
  const parts = path.split('.');
  let cur = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    if (!cur || typeof cur !== 'object') return;
    cur = cur[parts[i]];
  }
  // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
  if (cur && typeof cur === 'object') delete cur[parts[parts.length - 1]];
}

function browserOther(data) {
  const browser = data.browser;
  const other = browser && typeof browser === 'object' ? browser.other : null;
  return other && typeof other === 'object' ? other : null;
}

function stripMediaLabels(other) {
  const devices = other.media && other.media.devices;
  if (!Array.isArray(devices)) return;
  for (let i = 0; i < devices.length; i++) {
    if (devices[i] && typeof devices[i] === 'object') delete devices[i].label;
  }
}

function stripPermissions(other) {
  const permissions = other.capabilities && other.capabilities.permissions;
  if (!permissions || typeof permissions !== 'object') return;
  const keys = Object.keys(permissions);
  for (let i = 0; i < keys.length; i++) {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    if (keys[i] !== KEPT_PERMISSION) delete permissions[keys[i]];
  }
}

export function stripProductFields(data, products) {
  if (!data || typeof data !== 'object') return data;
  if (!products.fp) {
    for (let i = 0; i < FP_ONLY_PATHS.length; i++) deletePath(data, FP_ONLY_PATHS[i]);
  }
  if (!products.di) {
    for (let i = 0; i < DI_ONLY_PATHS.length; i++) deletePath(data, DI_ONLY_PATHS[i]);
    const other = browserOther(data);
    if (other) {
      stripMediaLabels(other);
      stripPermissions(other);
    }
  }
  return data;
}
